import type { RootState } from "@/services/store";

export const currentPersonSelector = (state: RootState) => state.contactsPage.currentPerson;

export const contactsIsEditSelector = (state: RootState) => state.contactsPage.contactsIsEdit;

export const formIsValidSelector = (state: RootState) => state.contactsPage.formIsValid;

export const formIsValidatingSelector = (state: RootState) => state.contactsPage.formIsValidating;

export const updateIsLoadingSelector = (state: RootState) => state.contactsPage.updateIsLoading;

export const groupFilterSelector = (state: RootState) => state.contactsPage.groupFilter;

export const nameFilterSelector = (state: RootState) => state.contactsPage.nameFilter;

export const sorterSelector = (state: RootState) => state.contactsPage.sorter;

export const titleFilterSelector = (state: RootState) => state.contactsPage.titleFilter;

export const swipedPersonSelector = (state: RootState) => state.contactsPage.swipedPerson;

export const isNewPersonSelector = (state: RootState) => {
  return state.contactsPage.currentPerson?.id.includes("new");
};
